<template>
  <div ref="container">
    <a-modal
      title="入库"
      width="80%"
      :visible="visible"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :wrapClassName="wrapClassNameInfo()"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="关闭"
      style="top:20px;height: 95%;">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper" >
        <a-table
          ref="table"
          size="middle"
          bordered
          :columns="columns"
          :dataSource="depotList"
           :scroll="{ x: true }"
          :loading="loading"
          :rowSelection="{type: 'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          >
        </a-table>
      </div>
    </a-modal>
  </div>
</template>

<script>
import BillDetail from './BillDetail'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import {mixinDevice} from '@/utils/mixin'
import { findBillDetailByNumber } from '@/api/api'
import { getAction, putAction } from '@/api/manage'
export default {
  name: 'WaitBillList',
  mixins:[JeecgListMixin, mixinDevice],
  components: {
    BillDetail
  },
  data () {
    return {
      parentRow:{},
      depotList:[],
      title: "操作",
      visible: false,
      disableMixinCreated: true,
      selectedRowKeys: [],
      selectedDetailRowKeys: [],
      selectBillRows: [],
      selectBillDetailRows: [],
      showType: 'basic',
      selectType: 'list',
      linkNumber: '',
      organId: '',
      discountMoney: '',
      deposit: '',
      remark: '',
      queryParam: {
        number: "",
        materialParam: "",
        type: "",
        subType: "",
        status: ""
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      // 表头
      columns: [
        { title: '仓库名称', dataIndex: 'depotName',width:145},
      ],
      columnsDetail: [
        { title: '条码', dataIndex: 'barCode',width:120},
        { title: '名称', dataIndex: 'name',width:100, ellipsis:true},
        { title: '规格', dataIndex: 'standard',width:120, ellipsis:true},
        { title: '型号', dataIndex: 'model',width:120, ellipsis:true},
        { title: '单位', dataIndex: 'unit',width:50},
        { title: '数量', dataIndex: 'operNumber',width:50},
        { title: '备注', dataIndex: 'remark',width:100, ellipsis:true},
      ],
      dataSource:[],
      dataSourceDetail: [],
      url: {
        list: "/depotHead/waitBillList"
      }
    }
  },
  computed: {
    getType: function () {
      return 'radio';
    }
  },
  created() {
  },
  methods: {
    show(parentRow) {
      this.parentRow = parentRow
      this.selectType = 'list'
      this.showType = 'other'
      this.columns[0].title = '供应商或客户'
      this.model = Object.assign({}, {});
      this.visible = true;
      getAction('/depot/findDepotByCurrentUser').then((res)=>{
        if(res.code === 200){
          this.depotList = res.data;
        }else{
          this.$message.info(res.data);
        }
      })
    },

    myHandleDetail(record) {
      findBillDetailByNumber({ number: record.number }).then((res) => {
        if (res && res.code === 200) {
          let type = res.data.depotHeadType
          type = type.replace('其它','')
          this.$refs.billDetail.show(res.data, type)
          this.$refs.billDetail.title=type+"-详情"
        }
      })
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    handleCancel () {
      this.close()
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onSelectDetailChange(selectedRowKeys) {
      this.selectedDetailRowKeys = selectedRowKeys;
    },
    handleOk () {
      getAction('/dataAcquisitionAccumulated/updateStorage',{
        headerId:this.parentRow.id,
        depotId:this.depotList[this.selectedRowKeys[0]].id
      }).then((res)=>{
        if(res.code === 200){
          this.$message.success(res.msg)
          this.$emit('ok')
          this.close()
        }else{
        }
      })
    },
    //查询明细列表
    loadDetailData(arg) {
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      if(this.selectBillRows && this.selectBillRows.length>0) {
        let record = this.selectBillRows[0]
        let param = {
          headerId: record.id,
          mpList : '',
          linkType: this.showType
        }
        this.loading = true;
        getAction('/depotItem/getDetailList', param).then((res) => {
          if (res.code===200) {
            let list = res.data.rows;
            let listEx = []
            for(let j=0; j<list.length; j++){
              let info = list[j];
              if(info.preNumber !== info.finishNumber) {
                //去掉已经全部转换的明细
                listEx.push(info)
              }
            }
            this.dataSourceDetail = listEx
            this.ipagination.total = res.data.total;
          }
          if(res.code===510){
            this.$message.warning(res.data)
          }
          this.loading = false;
        })
      }
    },
    onDateChange: function (value, dateString) {
      this.queryParam.beginTime=dateString[0];
      this.queryParam.endTime=dateString[1];
    },
    onDateOk(value) {
      console.log(value);
    },
    searchReset() {
      this.queryParam = {
        type: this.queryParam.type,
        subType: this.queryParam.subType,
        status: "1,3"
      }
      this.loadData(1);
    },
    getSelectBillRows() {
      let dataSource = this.dataSource;
      this.selectBillRows = [];
      for (let i = 0, len = dataSource.length; i < len; i++) {
        if (this.selectedRowKeys.includes(dataSource[i].id)) {
          this.selectBillRows.push(dataSource[i]);
        }
      }
    },
    getSelectBillDetailRows() {
      let dataSource = this.dataSourceDetail;
      this.selectBillDetailRows = [];
      for (let i = 0, len = dataSource.length; i < len; i++) {
        if (this.selectedDetailRowKeys.includes(dataSource[i].id)) {
          this.selectBillDetailRows.push(dataSource[i]);
        }
      }
    },
    rowAction(record, index) {
      return {
        on: {
          click: () => {
            let arr = []
            arr.push(record.id)
            this.selectedRowKeys = arr
          },
          dblclick: () => {
            let arr = []
            arr.push(record.id)
            this.selectedRowKeys = arr
            this.handleOk()
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>